import { gsap } from 'gsap';
import { BREAKPOINTS } from '@/js/lib/constants';

function handleSiteLoadNavAnimation() {
  const nav = document.querySelector('.js-nav');
  const navKey = 'nav-animated';
  const storage = sessionStorage.getItem(navKey);
  const media = window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`);

  if (!nav || storage || !media.matches) return;

  gsap.set(nav, {
    x: '-100%',
  });
  gsap.to(nav, {
    x: '0%',
    delay: 0.4,
    onComplete: () => {
      nav.setAttribute('style', '');
    },
  });
  sessionStorage.setItem(navKey, 'true');
}
handleSiteLoadNavAnimation();
